<template>
    <div class="app-wrapper">
        <div class="main-container">
            <app-main />
        </div>
        <el-backtop :visibility-height="60" :bottom="400"></el-backtop>
    </div>
</template>

<script>
import { AppMain } from "./components";

export default {
    name: "Layout",
    components: {
        AppMain,
    },
    computed: {
    },
    methods: {
    },
};
</script>

<style lang="scss" scoped>
// @import "~@/styles/mixin.scss";
// @import "~@/styles/variables.scss";

.app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }
}
.drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
}

.fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    // width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
}

.hideSidebar .fixed-header {
    width: calc(100% - 54px);
}

.mobile .fixed-header {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue